import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { HttpMethods } from '@cbre/http';
import { PrivacyMember, PrivacySettingsData, PrivacyTeam } from './privacy.model';
import { PlainOption } from '@shared/models/icommons.model';

@Injectable()
export class PrivateAssetSettingsService extends HttpMethods {
  constructor(http: HttpClient) {
    super(http);
  }

  public searchUsers(query: string): Observable<{ users: PrivacyMember[]; teams: PrivacyTeam[] }> {
    const params = new HttpParams({ fromObject: { query } });
    const uri = `/privacy/members`;
    return this.httpGet(uri, params) as Observable<{ users: PrivacyMember[]; teams: PrivacyTeam[] }>;
  }

  public getPrivacyReasons(): Observable<PlainOption[]> {
    const uri = `/lookup/privacy/reasons`;
    return this.httpGet(uri) as Observable<PlainOption[]>;
  }

  public savePrivacySettings(data: PrivacySettingsData): Observable<null> {
    const uri = `/privacy/record`;
    return this.httpPut(uri, data) as Observable<null>;
  }

  public getCurrentUser(userId: string): Observable<PrivacyMember> {
    const uri = `/users/${userId}/edp`;
    return this.httpGet(uri);
  }
}
